import { getApi } from "./api_instance";

export const notifications = async (dispatch) => {
  try {
    return await getApi({
      apiUrl: "/projects/api/notification/getNotifications",
      sendToken: true,
      dispatch,
    });
  } catch (error) {
    throw error;
  }
};
